import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const rkaRoute = createRoute({
    path: "/rka",
    name: "menu.rka",
    icon: "balance",
    accCode: "",
});

export const rkaPlanningRoute = createRoute({
    path: `${rkaRoute.path}/planning`,
    name: "rka_planning.",
    accCode: "",
    parentCode: rkaRoute.accCode,
});

export const rkaPlanningDetailRoute = createRoute({
    path: `${rkaPlanningRoute.path}/detail`,
    name: "rka_planning.detail",
    accCode: "",
    parentCode: rkaRoute.accCode,
});

export const rkaPlanningCreateRoute = createRoute({
    path: `${rkaPlanningRoute.path}/create`,
    name: "rka_planning.add",
    accCode: "",
    parentCode: rkaRoute.accCode,
    action: "create",
    redirectTo: rkaPlanningRoute.path,
});

export const rkaPlanningEditRoute = createRoute({
    path: `${rkaPlanningRoute.path}/edit`,
    name: "rka_planning.edit",
    accCode: "",
    parentCode: rkaRoute.accCode,
    action: "edit",
    redirectTo: rkaPlanningRoute.path,
});


// component
const RKA = lazy(() => import("../page/rka/RKA"));
const RKAPlanning = lazy(() => import("../page/rka/planning/RKAPlanning"));
const RKAPlanningForm = lazy(() => import("../page/rka/planning/form/RKAPlanningForm"));
const RKAPlanningView = lazy(() => import("../page/rka/planning/view/RKAPlanningView"));

export const RKAListRoutes = [
    rkaPlanningRoute
]

export const RKAMutationRoute = [
    rkaPlanningRoute, rkaPlanningCreateRoute, rkaPlanningEditRoute, rkaPlanningDetailRoute
]

export const rkaRoutes = {
    element: <RKA />,
    children: addHandleRoute([
        { ...rkaPlanningRoute, element: <RKAPlanning /> },
        { ...rkaPlanningCreateRoute, element: <RKAPlanningForm /> },
        { ...rkaPlanningEditRoute, element: <RKAPlanningForm /> },
        { ...rkaPlanningDetailRoute, element: <RKAPlanningView /> },
    ]),
};